import Application from './application';
import { service } from '@ember/service';

export default class InitiativeDocumentVersionAdapter extends Application {
  @service store;

  async list({ initiative_id }) {
    var url = `${this.host}/initiative-document-versions?filter%5Binitiative%5D=${initiative_id}`;

    let res = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        ...this.headers,
      },
    });
    if (res.status === 200) {
      const resJson = await res.json();

      resJson.data.forEach((item) => {
        if (item.type === 'INITIATIVE_DOC_VERSION')
          item.type = 'INITIATIVE-DOCUMENT-VERSION';
      });
      this.store.pushPayload(resJson);

      return true;
    } else {
      return false;
    }
    // return `${this.host}/people/${id}/claim`;
  }

  async restoreVersion({ version_id, initiative_id }) {
    var url = `${this.host}/initiative-document-versions/${version_id}/restore`;

    let res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...this.headers,
      },
      body: JSON.stringify({
        data: {
          relationships: {
            initiative: { data: { type: 'initiative', id: initiative_id } },
          },
        },
      }),
    });
    if (res.status >= 200 && res.status < 300) {
      return true;
    } else {
      return false;
    }
  }
}
